module.exports = __webpack_public_path__ + "static/media/video3.a368506d.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/video3.png
// module id = 973
// module chunks = 0